import { css } from '@emotion/css';
import { actImageUrl, commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { genreList } from 'Shared/common/Macros';
import { Show } from 'solid-js';
import { eventNameStyle } from 'Shared/frontend/eventPosters/separated/Utils';
import { poster } from 'Shared/frontend/SettingsProvider';


const posterStyle = (showEventName:boolean) => css({
	marginTop: showEventName ? 12 : 24,
	display: 'grid',
	gridTemplateColumns: '50% 50%',
});

const artistDetailsStyle = (alignLeft:boolean) => css({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: alignLeft ? 'flex-start' : 'flex-end',
	margin: '0.2em 0.5em'
});

const pressShotStyle = () => css({
	maxWidth: '100%'
});


export function ThreeActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'threeActs');

	const hide = () => s()?.hide ?? [];
	const showName = () => P.name && ! hide()?.includes('name');

	const eventSize = () => s().nameFontSize ?? theme().name.fontSize;
	const artistSize = () => s().artistNamesFontSize ?? theme().artistNames.fontSize;

	return (
		<div>
			<Show when={showName()}>
				<div class={css(eventNameStyle(),{fontSize:eventSize()})}>
					{P.name}
				</div>
			</Show>

			<div class={posterStyle(showName())}>
				<Artist {...P.lineup[0]} hide={hide()} fontSize={artistSize()} />
				<AltArtist {...P.lineup[1]} hide={hide()} fontSize={artistSize()} />
				<Artist {...P.lineup[2]} hide={hide()} fontSize={artistSize()} />
			</div>
		</div>
	);
}

function Artist(P)
{
	return (<>
		<img class={pressShotStyle()} src={actImageUrl(P.image)} width={132} height={88} />
		<ArtistDescription {...P} alignLeft={true} fontSize={P.fontSize} />
	</>);
}

function AltArtist(P)
{
	return (<>
		<ArtistDescription {...P} alignLeft={false} fontSize={P.fontSize} />
		<img class={pressShotStyle()} src={actImageUrl(P.image)} width={132} height={88} />
	</>);
}

function ArtistDescription(P)
{
	const artistNameStyle = () => css({
		fontSize: P.fontSize
	});

	const genresStyle = css(commonGenresStyle(), {
		fontSize: '0.6em',
		lineHeight: '1.5em'
	});

	return (
		<div class={artistDetailsStyle(P.alignLeft)}>
			<Show when={!P.hide.includes('artistName') && P.name}>
				<div class={artistNameStyle()}>{P.name}</div>
			</Show>
			<Show when={!P.hide.includes('artistGenres') && P.mainGenre}>
				<div class={genresStyle}>{ genreList(P) }</div>
			</Show>
		</div> 
	);
}

